import { BaseFile, BaseFolder, BaseNode, isFolder, NodeType } from './base';
import {
  AuditDataDto,
  DocumentVersionUpdaterUserDto,
  ExpiredVariableDto,
  Status,
  TemplateWithUpdateDto,
} from 'services/api/api-client';

export enum FolderStatus {
  NotStarted,
  InProgress,
  NotApplicable,
  Signed,
}

export const isDocument = (node: BaseNode): node is DocumentNode =>
  node.type === NodeType.Document;

export const isDocumentFolder = (node: BaseNode): node is DocumentFolderNode =>
  isFolder(node) && isDocumentTreeNode(node);

export const isDocumentTreeNode = (
  node: BaseNode,
): node is BaseDocumentTreeNode =>
  node && 'projectId' in node && 'revisionId' in node;

export type BaseDocumentTreeNode = {
  projectId: number;
  revisionId: number;
} & BaseNode;

export type DocumentTreeNode = DocumentNode | DocumentFolderNode;

export type DocumentNode = {
  type: NodeType.Document;
  version: string;
  status: Status;
  isReadOnly: boolean;
  isOpenXml: boolean;
  expiredVariables: ExpiredVariableDto[];
  templateWithUpdate: TemplateWithUpdateDto | null;
  versionUpdaterUser: DocumentVersionUpdaterUserDto | null;
  onDocumentEdit?: (
    documentItemId: string,
    editedStatus: string,
    editedProperty: 'name' | 'status',
  ) => Promise<void>;
  auditData: AuditDataDto | null;
  date: string;
} & BaseFile &
  BaseDocumentTreeNode;

export type DocumentFolderNode = {
  folderStatus: FolderStatus;
  onFolderEdit: (
    folderId: string,
    editedName: string,
    editedProperty: 'name' | 'status',
  ) => Promise<void>;
} & BaseFolder<BaseDocumentTreeNode> &
  BaseDocumentTreeNode;
